import httpService from '@/services/httpService'

export const types = {
  SET_SETTINGS: 'reporting/SET_SETTINGS',
  SET_OPTS: 'reporting/SET_OPTS',
  SET_REPORTS: 'reporting/SET_REPORTS'
}

const state = {
  opts: [],
  settings: {},
  reports: []
}

const mutations = {
  [types.SET_OPTS]: function (state, opts) {
    state.opts = opts
  },
  [types.SET_SETTINGS]: function (state, settings) {
    state.settings = settings
  },
  [types.SET_REPORTS]: function (state, reports) {
    state.reports = reports
  }
}

const actions = {
  getReportData: async function ({ commit }, { clientId, filters }) {
    const params = { filters: JSON.stringify(filters) }
    const response = await httpService.get(`/reporting/${clientId}`, { params })
    if (!response || !response.data) {
      return
    }
    commit(types.SET_REPORTS, response.data)
    return response.data
  },
  createNewReport: function ({ commit }, { clientId, report }) {
    return httpService.post(`/reporting/${clientId}`, report,
      { successMessage: 'Export successfully created', raiseError: true, cancelErrorMessage: true })
  },
  getReportSettings: async function ({ commit }, clientId) {
    const response = await httpService.get(`/reporting/settings/${clientId}`)
    if (!response || !response.data) {
      return
    }
    commit(types.SET_SETTINGS, response.data)
    return response.data
  },
  getReportOptions: async function ({ commit }) {
    const response = await httpService.get('/reporting/options')
    if (!response || !response.data) {
      return
    }
    commit(types.SET_OPTS, response.data)
    return response.data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
